export default "/b554e21ed8a659b822597c92967d1f4c2aa51bb5/83e791c702f67cc0242109b04d241be7.svg";